/*
 * Module for the Factors tab displayed within the Calculation Details popup on
 * the DROP Enrollment wizard's Calculation Results step
*/
rs.module("participant/benefit/setup/drop/wizard/calculationdetailsfactorstab",

    [ ],

    function () {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, variables, backendUrls) {

            // get JS selectors
            var container = $.js(jsSelectors.container);
            var factorPlanSelect = container.js(jsSelectors.factorPlanSelect);
            var factorPlanLoadingSpinner = container.js(jsSelectors.factorPlanLoadingSpinner);
            var factorsDetailContainer = container.js(jsSelectors.factorsDetailContainer);

            // Hookup factorPlanSelect change event
            factorPlanSelect.change(updateFactorsDetail);

            // Update the Factor Detail display
            function updateFactorsDetail() {

                var selectedPlanKey = factorPlanSelect.val();

                factorPlanLoadingSpinner.show();

                $.get(backendUrls.getFactorsDetail,
                    {
                        benefitClaimPaymentKey: variables.benefitClaimPaymentKey,
                        planKey: selectedPlanKey
                    })
                    .done(function (html) {
                        factorsDetailContainer.html(html)
                    }).always(function () {
                        factorPlanLoadingSpinner.hide();
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);